<div
  class="lineitem-search-container"
  [ngClass]="[onScreen ? 'on-screen-lineitem-search-container' : 'modal-lineritem-search', className]"
>
  <!-- <va-icon name="faSearch" class="fa-md search-icon"></va-icon> -->
  <nz-input-group
    [nzSize]="inputSize"
    id="search-input"
    [nzPrefix]="prefixTemplateUser"
    class="lim-search-input"
  >
    <input
      type="text"
      #search
      [formControl]="queryField"
      (keyup.arrowup)="lineItemSearchKeyChange($event, 'up')"
      (keyup.arrowdown)="lineItemSearchKeyChange($event, 'down')"
      (keyup.enter)="lineItemSearchKeyChange($event, 'enter')"
      (click)="inputClicked()"
      nz-input
      [readonly]="disabled"
      [(ngModel)]="searchText"
      [placeholder]="placeholder"
    />
  </nz-input-group>
  <nz-cascader
    [nzExpandTrigger]="'hover'"
    [nzOptions]="nzOptions"
    [(ngModel)]="values"
    [nzShowSearch]="false"
    (nzSelectionChange)="onChanges($event)"
    [nzSize]="'small'"
    [nzOptionRender]="renderTpl"
    [nzPlaceHolder]="placeholder"
    [nzMenuClassName]="
      'lineitem-search ' +
      cascaderClassName +
      (!hasContent ? ' lineitem-no-content' : '')
    "
    [nzShowInput]="false"
    (nzVisibleChange)="onVisibleChange($event)"
  >
    <nz-input-group
      [nzSize]="'small'"
      [id]="lineItemInputId"
      [nzPrefix]="prefixTemplateUser"
    >
      <input type="text" nz-input [placeholder]="placeholder" />
    </nz-input-group>
    <ng-template #prefixTemplateUser
      ><va-icon
        size="small"
        name="search"
        class="fa-md lineitem-search-icon"
        [ngClass]="onScreen === true ? 'screen-icon' : ''"
      ></va-icon
    ></ng-template>
  </nz-cascader>
  <ng-template #renderTpl let-option let-index="index">
    <div
      *ngIf="option.suggestion_header"
      style="padding-left: 8px; padding-bottom: 4px; color: #979797; font-weight: 600; font-size: 14px;"
    >
      {{ option.suggestion_header }}
    </div>
    <div
      *ngIf="!option.suggestion_header && !option.suggestion_footer"
      class="items"
      [ngClass]="{
        'level-1': option.level == 1,
        'level-2': option.level == 2,
        'level-3': option.level == 3,
        'cascade-option-header': option.info,
        header: option.header == true,
        'screen-level-3': option.level == 3 && onScreen === true
      }"
      [ngStyle]="{
        'max-width': option.index !== undefined ? '356px' : 'inherit'
      }"
      (click)="onClickOption(option)"
    >
      <span class="option-label-name">
        {{ option.label
        }}
      </span><ng-container *ngIf="option.line_count"
        >&nbsp;({{ option.line_count }})</ng-container
      >
    </div>
    <div
      *ngIf="option.suggestion_footer"
      style="padding: 4px 12px 16px 8px; color: #979797; font-size: 14px; white-space: nowrap;"
      [ngStyle]="{ color: totalLiAdded >= maxCount ? 'red' : '#979797' }"
    >
      {{ option.suggestion_footer }} {{ totalLiAdded }}/{{ maxCount }}
    </div>
  </ng-template>
</div>
